// Photo viewer on the Media page and the new fields of the photo detail drawer.
export const mediaViewer = {
  viewer: {
    dialogLabel: "Photo viewer",
    prev: "Previous photo",
    next: "Next photo",
    star: "Mark as a good photo",
    unstar: "Unmark good photo",
    delete: "Move to trash",
    openDetail: "Open detail",
    close: "Close viewer",
    position: "{{current}} / {{total}}",
    loading: "Loading photo…",
    noName: "untitled",
  },
  legend: {
    title: "Keyboard shortcuts",
    next: "Next photo",
    prev: "Previous photo",
    star: "Good photo on / off",
    delete: "Move to trash",
    detail: "Open detail",
    close: "Close",
  },
  meta: {
    fileName: "File name",
    dimensions: "Dimensions",
    orientation: "Orientation",
    countries: "Countries",
    noCountry: "No country",
    source: "Source",
    noSource: "–",
    usageLabel: "Usage",
    usage_one: "Used in {{count}} place",
    usage_few: "Used in {{count}} places",
    usage_other: "Used in {{count}} places",
  },
  tags: {
    label: "Tags",
    placeholder: "Add a tag and press Enter",
    add: "Add tag",
    remove: "Remove tag {{tag}}",
    hint: "Saved right away; library search finds the photo by its tags.",
  },
  confirmDelete: {
    title: "Move a used photo to trash?",
    message_one: "The photo is used in {{count}} place. Really move it to trash?",
    message_few: "The photo is used in {{count}} places. Really move it to trash?",
    message_other: "The photo is used in {{count}} places. Really move it to trash?",
    confirm: "Move to trash",
  },
  drawer: {
    countries: "Countries",
    source: "Source",
    sourcePlaceholder: "Where the photo comes from (stock bank, author…)",
    starred: "Good photo",
    liveTwin: "Live photo",
  },
  usageKind: {
    destination: "Destination",
    trip: "Trip",
    hotel: "Hotel",
    inspiration: "Inspiration",
    blogPost: "Article",
    contentPage: "Page",
    guide: "Guide",
    destinationTeam: "Destination team",
    premiumUpgrade: "Premium upgrade",
    review: "Review",
    departurePhoto: "Departure photo",
    jobOffer: "Job offer",
    newsletterCampaign: "Newsletter campaign",
    setting: "Setting",
    user: "User",
  },
};
